export default function AuthHeader() {
  const user = window.localStorage.getItem("accessToken");

  if (user) {
    return {
      Authorization: "Bearer " + user,
    };
  } else {
    return {
      Authorization: "Bearer " + user,
    };
  }
}
// [0].reg.data.data.token.access_token
